<div class="btn-group pt-0 col-md-12 text-left well-done-sidebar-top-header" role="group" aria-label="Basic example">
    <button (click)="setMenuActive('notification')"
            [ngClass]="activeMenu === 'notification' ? 'btn-live' : 'btn-outline-secondary'" type="button"
            class="btn btn-sm "><i class="lni lni-target"></i> Uživo pregled
    </button>
    <button (click)="setMenuActive('activity')"
            [ngClass]="activeMenu === 'activity' ? 'btn-live' : 'btn-outline-secondary'" type="button"
            class="btn btn-sm ">Aktivnosti
    </button>
    <button type="button" (click)="setMenuActive('watch')"
            [ngClass]="activeMenu === 'watch' ? 'btn-live' : 'btn-outline-secondary'"
            class="btn btn-sm  watching-button">
        Watching
        <span style="color: white"
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger ml-1" title="Ukupan broj zadataka za odobravanje">
    {{totalTasksForValidation}}

  </span>
    </button>
</div>
<div class="col-md-12 mt-3" style="max-height: 90vh; overflow-y: scroll">
    <app-sidebar-content-notification-center
            *ngIf="activeMenu === 'notification'"></app-sidebar-content-notification-center>
    <app-sidebar-content-activity-center *ngIf="activeMenu === 'activity'"></app-sidebar-content-activity-center>
    <app-sidebar-content-watching-center *ngIf="activeMenu === 'watch'"
                                         (outputTotalTasksForValidation)="totalTasksForValidationHandler($event)"></app-sidebar-content-watching-center>
</div>

